// extracted by mini-css-extract-plugin
export var container = "dw_g";
export var fadeDiv = "dw_f0";
export var placeholderWrapper = "dw_q0";
export var video = "dw_q1";
export var videoWrapper = "dw_hW";
export var vimeoPlayer = "dw_q2";
export var wrapper = "dw_B";